import cn from 'classnames';
import { ReactElement } from 'react';
import { FullSubNavItem, FullSubNavLocation } from '../../utils/routing/location-constants';
import { useBpmNavigate } from '../../utils/routing/useBpmNavigate';
import { Button } from '../Button';
import { Appearance, Background, Size } from '../designConstants';
import { NAV_ITEM_HEIGHT } from './navbar-constants';
import { TertiaryNavMenu } from './TertiaryNavMenu';

interface SubNavMenuProps {
  parentPrettyName: string;
  subNavs: FullSubNavItem[];
  expanded: boolean;
}

export const SubNavMenu = ({
  parentPrettyName,
  subNavs,
  expanded
}: SubNavMenuProps): ReactElement => (
  <div
    className={cn('subnav-menu', { expanded })}
    style={{ height: expanded ? NAV_ITEM_HEIGHT * subNavs.length : 0 }}
  >
    {subNavs.map(subNav =>
      'tertiaryNavs' in subNav ? (
        <TertiaryNavMenu
          key={subNav.key}
          parentPrettyName={parentPrettyName}
          tertiaryNav={subNav}
        />
      ) : (
        <SubNavMenuItem key={subNav.key} subNav={subNav} />
      )
    )}
  </div>
);

interface SubNavMenuItemProps {
  subNav: FullSubNavLocation;
}

const SubNavMenuItem = ({ subNav }: SubNavMenuItemProps): ReactElement => {
  const navigate = useBpmNavigate();
  const { fullPath, prettyName, type } = subNav;

  return (
    <Button
      size={Size.LG}
      data-testid='subnav-item'
      appearance={Appearance.EMPTY}
      background={Background.DARK}
      className='subnav-menu-item'
      onClick={() => navigate({ type, path: fullPath, prettyName })}
    >
      {prettyName}
    </Button>
  );
};
